<template>
    <div class="page">
        <blue-title>已开通渠道</blue-title>
        <div class="container">
            <div class="nonactivated" v-if="alreadyList.length>0">
                <channel-item v-for="item of alreadyList" :key="item.title" :channel="item" @click.native="jump(1, item)" />
            </div>
            <p class="placeholder" v-else>暂无已开通渠道</p>
        </div>
        <blue-title>未开通渠道</blue-title>
        <div class="container nonactivated">
            <channel-item v-for="item of channelList" :key="item.title" :channel="item" @click.native="jump(2, item)" />
        </div>
    </div>
</template>

<script>
import { channel, heepayChannel } from '@set-up/static/data.js';
import channelItem from '@set-up/components/channel-item.vue';
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  name: 'channel',
  components: { channelItem },
  computed: {
    ...mapGetters('channel', ['mchchanList']),
    ...mapState('main', ['merchantInfo']),
  },
  data() {
    return {
      channelList: [],
      channel,
      heepayChannel,
      alreadyList: [],
    };
  },
  methods: {
    ...mapActions('channel', ['getMchchanList']),
    ...mapActions('main', ['getMerchantInfo']),
    // 获取支付平台已开通列表
    async getChannelList() {
      await this.getMchchanList({ applyCode: JSON.parse(localStorage.getItem('checkdApply')).applyCode });
      await this.getAlready();
    },
    // 筛选已开通渠道
    getAlready() {
      this.mchchanList.map((item) => {
        this.channelList.forEach((ele, index) => {
          if (item.chanCode == ele.category.toUpperCase() && item.type == ele.type) {
            this.channelList.splice(index, 1);
            ele.status = true;
            this.alreadyList.push(Object.assign(ele, { id: item.id }));
          }
        });
      });
    },
    // 跳转未开通渠道
    jump(val, item) {
      var query = { category: item.category, type: item.type };
      if (val == 1) {
        query.id = item.id;
        if(item.category=='heepay') query.id = 'heepay';
      }
      this.$router.push({ name: 'setup/channel/edit', query: query });
    },
  },
  async mounted() {
    this.channelList = [];
    if (JSON.parse(localStorage.getItem('checkdApply')).applyType === 'HEEMONEY') {
      //汇付宝渠道
      await this.getMerchantInfo({ applyCode: JSON.parse(localStorage.getItem('checkdApply')).applyCode });
      if (this.merchantInfo) {
        this.heepayChannel.get('heepay')[0].status= true;
        this.alreadyList = this.heepayChannel.get('heepay');
      } else {
        this.channelList = this.heepayChannel.get('heepay');
      }
    } else {
      this.channelList = [...this.channel.get('wechat'), ...this.channel.get('alipay')];
      await this.getChannelList();
    }
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.page {
  flex: 1;
  background-color: @bg-white;
  padding: 25px 0 48px 0;
  .container {
    margin-bottom: 3em;
    padding-left: 2.3em;
    .placeholder {
      font-size: 16px;
      color: @font-color-info;
      margin-top: 20px;
    }
  }
  .nonactivated {
    .box_row();
    flex-wrap: wrap;
  }
}
</style>
